import { render, staticRenderFns } from "./OfficialCompensation3.vue?vue&type=template&id=45dfb7fa&scoped=true"
import script from "./OfficialCompensation3.vue?vue&type=script&lang=js"
export * from "./OfficialCompensation3.vue?vue&type=script&lang=js"
import style0 from "./OfficialCompensation3.vue?vue&type=style&index=0&id=45dfb7fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfb7fa",
  null
  
)

export default component.exports